import { useMutation } from 'react-query';
import { EOrderStatus } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/order.interface';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { UseMutationInterface } from 'src/reactQuery/customers/mutations/interfaces/useUpdateCustomer.interface';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { updateOrderGroupStatus } from 'src/services/napi/ordersGroup/updateOrderGroup';

const updateOrderFn = async (orderId: string, body: EOrderStatus): Promise<void> => {
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );
  if (!currentProject) return;
  await updateOrderGroupStatus(currentProject._id, orderId, body);
};

export const useUpdateOrderGroup = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation(
    // @ts-ignore-next-line
    (params: { body: EOrderStatus; orderId: string }) => {
      updateOrderFn(params.orderId, params.body);
    },
    {
      onError: () => {
        notify({ message: 'something went wrong', severity: 'error' });
        if (onError) {
          onError();
        }
      },
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
      }
    }
  );
};
